<template>
  <div>
    <div class="embed-responsive embed-responsive-16by9">
      <div id="vidBox" class="player embed-responsive-item" ref="vidBox"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'videoplayerComponent',
  props: ['id', 'type'],
  methods: {
    initialize() {
      var target = document.getElementById('vidBox')
      this.initializePlayerWithAds(this.id, target, this.type)
    }
  },
  watch: {
    id: function(newVal) {
      var target = document.getElementById('vidBox')
      this.initializePlayerWithAds(newVal, target, this.type)
    }
  },
  beforeMount() {
    var target = document.getElementById('vidBox')
    this.initializePlayerWithAds(this.id, target, this.type)
  }
}
</script>

<style></style>
